import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Heading } from "../common/Heading/Heading";
import { InvitationsTable } from "./InvitationsTable/InvitationsTable";
import { CreateInvitationModal } from "./CreateInvitationModal/CreateInvitationModal";
import { useTranslation } from "react-i18next";
import { Button } from "../common/Button/Button";
import { useData } from "../../context/DataContext";

export const Invitations = () => {
  const { t } = useTranslation();
  const {
    invitations,
    isLoading,
    error,
    deleteInvitation,
    fetchFullInvitationData,
  } = useData();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (!invitations.length) {
      fetchFullInvitationData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <ContentWrapper>
        <TitleSection>
          <Heading text={t("invitations.invitations")} size={1} />
          <Button
            text={t("invitations.createInvitation")}
            onClick={() => setIsModalOpen(true)}
            variant="primary"
            disabled={isLoading}
          />
        </TitleSection>

        {error && <ErrorMessage>{error}</ErrorMessage>}

        <InvitationsTable
          invitations={invitations}
          isLoading={isLoading}
          onDelete={deleteInvitation}
        />

        <CreateInvitationModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </ContentWrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

const ContentWrapper = styled.div``;

const TitleSection = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 2rem;
  gap: 1rem;
`;

const ErrorMessage = styled.div`
  color: #d52566;
  background-color: #fff5f7;
  border: 1px solid #ffc2d1;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
`;
